import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_REPORT_LIST = createActionTypes('FETCH_REPORT_LIST');
export const FETCH_REPORT_DOWNLOAD_REQUEST = createActionTypes('FETCH_REPORT_DOWNLOAD_REQUEST');
export const CREATE_REPORT_DOWNLOAD_REQUEST = createActionTypes('CREATE_REPORT_DOWNLOAD_REQUEST');
